export const SupplierContactValidation = (formData) => {
    const errors = {};
    

    if (!formData.vc_Title || !formData.vc_Title.trim()) {
        errors.vc_Title = 'This field is required';
    }

    if (!formData.vc_FirstName || !formData.vc_FirstName.trim()) {
        errors.vc_FirstName = 'This field is required';
    }

    if (!formData.vc_SurName || !formData.vc_SurName.trim()) {
        errors.vc_SurName = 'This field is required';
    }

    if (!formData.vc_Email || !formData.vc_Email.trim()) {
        errors.vc_Email = 'This field is required';
    } else if (!isValidEmail(formData.vc_Email)) {
        errors.vc_Email = 'Please enter a valid email address';
    }


    return errors;
};
const isValidEmail = (email) => {
    // You can implement a regex or use a library like validator.js to validate email format
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};